import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { BaseControlValueAccessor } from "../base_control_value_accessor/base";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { AutoSearchService } from '../auto-search/auto-search.service';

@Component({
  selector: 'app-toggle-select',
  templateUrl: './toggle-select.component.html',
  styleUrls: ['../form-field.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ToggleSelectComponent),
    }
  ]
})
export class ToggleSelectComponent extends BaseControlValueAccessor implements OnInit {

  @Input()
  displayField: string = null;

  @Input()
  options = [];

  @Input()
  defaultDisplay = '-';

  getDisplay(item) {
    if (item == null)
      return this.defaultDisplay;

    if (this.displayField == null)
      return item;
    return item[this.displayField];
  }

  @Input()
  retrieveUrlTransforms: Object = {};

  loading = false;

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  isEqualObj(val1, val2) {
    val1 = JSON.stringify(val1);
    val2 = JSON.stringify(val2);
    return val1 == val2;
  }
}


